



import { Component, Vue } from 'vue-property-decorator'

@Component
export default class WhyUs extends Vue {

  readonly yearsOnMarket = new Date().getFullYear() - 2000
}
